import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { About } from "./navigation/About"
import { Contact } from "./navigation/Contact"
import { Home } from "./navigation/Home"
import { Offer } from "./navigation/Offer"
import { Services } from "./navigation/Services"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />, // App component now acts as the layout
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/offer",
        element: <Offer />,
      },
    ],
  },
])

root.render(
  <React.StrictMode>
    <RouterProvider router={router}></RouterProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
